import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa en cocina?',
  answer: 'No, las recetas están explicadas paso a paso para principiantes absolutas'
}, {
  question: '¿Cuándo recibo el ebook?',
  answer: 'Inmediatamente después del pago, directo a tu email'
}, {
  question: '¿Funciona para cualquier ciudad de Argentina?',
  answer: 'Sí, los costos y precios son adaptables a cualquier zona'
}, {
  question: '¿Necesito equipamiento especial?',
  answer: 'Solo un bol, horno y bandeja — nada que no tengas ya en tu cocina'
}, {
  question: '¿Qué incluye exactamente?',
  answer: 'El ebook principal con 10 recetas + módulos de costos, precios y ventas + los 4 bonus'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark relative" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-69">
          <h2 className="text-4xl md:text-5xl font-bold" data-id="element-70">
            Preguntas{' '}
            <span className="text-gold italic font-normal" data-id="element-71">frecuentes</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-72">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-charcoal border border-white/10 rounded-2xl overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-74">
                <span className="text-lg font-medium text-cream pr-4" data-id="element-75">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-78">
                    <div className="px-6 pb-6 text-cream-muted/80" data-id="element-79">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}